import { yupResolver } from '@hookform/resolvers/yup';
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useReinitializeForm } from 'hooks';
import { useGetMembercenterPlansQuery, useGetUserQuery } from 'store/api/version-api.slice';
import { RENEW_USER_PAYMENT_FORM } from 'constants/initial-values';

import PAYMENT_FORM_SCHEMA from './paymentForm.schema';
import SquareUserPaymentForm from './SquareUserPaymentForm';
import { getPaymentProcessor, PAYMENT_PROCESSOR } from './utils';
import StripeUserPaymentForm from './StripeUserPaymentForm';

const ContainerUserPaymentForm = ({
	isLoading,
	onSubmitHandler,
	isRenewForm,
	memberTypes,
	setLoading,
	initialValues
}) => {
	const { data: membercenterPlansResponse = {} } = useGetMembercenterPlansQuery();
	const { data: userData = {} } = useGetUserQuery();

	const preselectedMemberType = memberTypes?.[0]?.id ?? '';

	const memberCenterPlans = useMemo(
		() => membercenterPlansResponse.results || [],
		[membercenterPlansResponse.results]
	);

	const methods = useForm({
		defaultValues: initialValues || RENEW_USER_PAYMENT_FORM,
		resolver: yupResolver(PAYMENT_FORM_SCHEMA)
	});

	const initValues = useMemo(() => {
		if (isRenewForm) return { ...initialValues, plan_type: preselectedMemberType };

		return {
			...initialValues,
			email: userData.email,
			first_name: userData.first_name,
			last_name: userData.last_name,
			save_card_information: true
		};
	}, [initialValues, isRenewForm, userData.email, userData.first_name, userData.last_name, preselectedMemberType]);

	useReinitializeForm({
		reset: methods.reset,
		formValues: initValues
	});

	const paymentProcessor = getPaymentProcessor(userData);

	const shouldRenderStripeForm = isRenewForm && paymentProcessor === PAYMENT_PROCESSOR.stripe;

	if (!paymentProcessor) return null;

	return (
		<FormProvider {...methods}>
			{shouldRenderStripeForm ? (
				<StripeUserPaymentForm
					plans={isRenewForm ? memberTypes : memberCenterPlans}
					isRenewForm={isRenewForm}
					onSubmitHandler={onSubmitHandler}
					setLoading={setLoading}
					userData={userData}
				/>
			) : (
				<SquareUserPaymentForm
					plans={isRenewForm ? memberTypes : memberCenterPlans}
					isLoading={isLoading}
					isRenewForm={isRenewForm}
					onSubmitHandler={onSubmitHandler}
					setLoading={setLoading}
					initialValues={initialValues}
				/>
			)}
		</FormProvider>
	);
};

export default ContainerUserPaymentForm;
